const actions = {};
const mutations = {
    setObject(state, { key, val }) {
        if (state.hasOwnProperty(key)) {
            state[key] = val;
        }
    },
    setOldCustomerField(state, isOldCustomer) {
        state.isOldCustomer = isOldCustomer;
    },
    setCurrentScoreData(state, obj) {
        state.currentScoreData = obj;
    },
    setSelectedGift(state, obj) {
        state.selectedGift = obj;
    },
};
const state = {
    isOldCustomer: false,
    currentScoreData: {},
    selectedGift: {}
};
const getters = {
    getHomeData(state, getters, rootState, rootGetters) {
        return state['homeData'];
    },
    currentScore(state) {
        return state.currentScoreData.totalScore || 0;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
